// extracted by mini-css-extract-plugin
module.exports = {"queries-link":"index_queries-link_2wjYE","queriesLink":"index_queries-link_2wjYE"};